import CreateActionsVM from './create-actions-vm';
import Vue from 'vue';
import 'libs/vue-extensions';

export default {
  init(element) {
    let vm = new Vue(CreateActionsVM);
    let parsedContent = JSON.parse(element.dataset.courseContent);
    let copyAction = parsedContent.copy_action;

    parsedContent.wizard_attrs = {};
    parsedContent.wizard_attrs.showCancelBtn = false;

    // courses is only for clone, for export there is only one course
    if(copyAction == 'clone') {
      parsedContent.courses = JSON.parse(parsedContent.courses);
      parsedContent.wizard_attrs.steps = cloneSteps();
      parsedContent.wizard_attrs.finalStepLabel = I18n.t('course.action.clone_course');
    } else if (copyAction == 'export') {
      parsedContent.course = JSON.parse(parsedContent.course);
      parsedContent.wizard_attrs.steps = exportSteps();
      parsedContent.wizard_attrs.finalStepLabel = I18n.t('course.action.export_course');
    } else if (copyAction == 'move') {
      parsedContent.courses = JSON.parse(parsedContent.courses);
      parsedContent.wizard_attrs.steps = moveSteps();
      parsedContent.wizard_attrs.finalStepLabel = I18n.t('course.action.move_course');
    }

    vm.bindData(parsedContent);
    vm.$mount(element);
  }
};


let cloneSteps = () => {
  return [{
    label: I18n.t('clone_steps.select_course'),
    title: `${I18n.t('dict.step')} 1`,
    icon: 'kf-info',
  },
  {
    label: I18n.t('clone_steps.select_content'),
    title: `${I18n.t('dict.step')} 2`,
    icon: 'kf-plus',
  },
  {
    label: I18n.t('clone_steps.review'),
    title: `${I18n.t('dict.step')} 3`,
    icon: 'kf-checkmark',
  }];
};

let moveSteps = () => {
  return [{
    label: I18n.t('clone_steps.select_course'),
    title: `${I18n.t('dict.step')} 1`,
    icon: 'kf-info',
  }];
};

let exportSteps = () => {
  return [{
    label: I18n.t('wizard.course_content'),
    title: `${I18n.t('dict.step')} 1`,
    icon: 'kf-info',
  },
  {
    label: I18n.t('wizard.review'),
    title: `${I18n.t('dict.step')} 2`,
    icon: 'kf-checkmark',
  }];
};
